import { withAuth } from '@utilities/queries';
import { getPortfolios, getUacCheck } from '@simplywallst/services';

export async function queryFn() {
  const [userAccess, response] = await Promise.all([
    await withAuth(getUacCheck),
    await withAuth(getPortfolios, undefined),
  ]);
  const portfolios = response.data.data.concat().sort((a, b) => {
    let aDate = 0;
    let bDate = 0;
    if (typeof b.date_generated === 'number') {
      bDate = b.date_generated;
    }
    if (typeof a.date_generated === 'number') {
      aDate = a.date_generated;
    }
    return (bDate || 0) - (aDate || 0);
  });

  return {
    portfolios,
    userAccess,
  };
}

export const queryKey = 'GET_USER_PORTFOLIOS' as const;
